module.exports = __webpack_public_path__ + "media/images/static/top/local/cta_btn_left-51ab2f7aa3c22abf27cb303243522bfc.png";